import { render, staticRenderFns } from "./PostAdmin.vue?vue&type=template&id=4008e684&"
import script from "./PostAdmin.vue?vue&type=script&lang=js&"
export * from "./PostAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports